<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import { selectedGroup } from '../store';
    import http from '../api/http.js';
    import {Button, Modal, ModalBody, ModalFooter, ModalHeader, CustomInput } from 'sveltestrap';
    let shown =false;
    const dispatch = createEventDispatcher();
    const toggle = () => (shown = !shown);
    let computer;
   
    export async function show(computerArg) {
        computer = computerArg;
        shown = true;
    }

    async function deleteComputer() {
        const res = await http.put(window.apiBaseUrl + `/deploy/dashboard/computers/${computer.id}/${$selectedGroup}`);
        if (res.ok) {
            dispatch('computerDeleted');
            shown = false;
        }
    }

    function _onYes() {  
        deleteComputer();
        shown = false;
    }    
   
    function _onNo() {
        shown = false;
    }
   </script>
   
   <Modal isOpen={shown} {toggle}>
       <ModalHeader {toggle}>
           Delete Computer
       </ModalHeader>
       <ModalBody>
           <p>Are you sure you want to delete <strong class="text-info">{computer.hostName}</strong>?</p>
           <p class="text-danger"><i class="fa fa-exclamation-triangle"></i> This action is <strong>Permanent</strong> and cannot be undone are you sure you wish to continue?</p> 
       </ModalBody>
       <ModalFooter>
            <button id="delete-computer-cancel-button" class="btn btn-outline-primary" on:click={() => _onNo()}>Cancel</button>
           <button id="delete-computer-confirm-button" on:click={() => _onYes()} class="btn btn-primary">Confirm</button>
       </ModalFooter>
    </Modal>
